import {route} from "ziggy-js";

const isRoute = (url: string) => {
    return route().current(url)
}

const isPath = (path: string) => {
    return window.location.pathname.includes(path)
}

export const useRoute = () => {
    return {
        isRoute,
        isPath,
    }
}
